export default __webpack_public_path__ + "static/media/logo192x192.44fb0ac3.png";